import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import clsx from "clsx";

export default function Header({ backgroundColor = "bg-eryndra-forest/20" }) {
  const [showBackground, setShowBackground] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackground(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
    <header
      className={clsx(
        "w-full fixed top-0 z-30 px-4 sm:px-6 md:px-8 py-2 flex justify-between items-center transition-colors duration-500",
        {
          "bg-transparent": !showBackground,
          [backgroundColor]: showBackground,
          "backdrop-blur-md": showBackground,
        }
      )}
    >
      <a
        href="/"
        className="font-title font-normal text-xl md:text-2xl font-extrabold tracking-widest text-shadow-sm text-eryndra-ivory"
      >
        eRYNDRA
      </a>

      {/* Botón menú hamburguesa en móvil */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="md:hidden text-eryndra-ivory"
        aria-label="Abrir menú"
      >
        {isMenuOpen ? <X className="w-6 h-6" /> : <Sparkles className="w-6 h-6" />}
      </button>

      {/* Menú solo visible en escritorio */}
      <nav className="hidden md:flex gap-6 text-md uppercase font-semibold">
        <div className="group relative text-left">
          <a
            href="#"
            className="transition-all duration-300 border-b-2 border-transparent"
          >
            Servicios
          </a>
          <div className="absolute left-0 hidden group-hover:block bg-eryndra-forest/90 border border-eryndra-gold rounded-md shadow-lg z-50">
            <ul className="py-2 px-2 text-eryndra-cream whitespace-nowrap">
              <li>
                <a
                  href="/celebraciones"
                  className="block px-4 py-2 hover:text-eryndra-gold transition-colors"
                >
                  Celebraciones a medida
                </a>
                <hr className="border-eryndra-gold my-1" />
              </li>
              <li>
                <a
                  href="/bailes"
                  className="block px-4 py-2 hover:text-eryndra-gold transition-colors"
                >
                  Bailes de fantasía
                </a>
                <hr className="border-eryndra-gold my-1" />
              </li>
              <li>
                <a
                  href="/eventos"
                  className="block px-4 py-2 hover:text-eryndra-gold transition-colors"
                >
                  Eventos literarios
                </a>
              </li>
            </ul>
          </div>
        </div>
         {/* NUEVO: Dropdown Eventos */}
          <div className="group relative text-left">
            <a
              href="#"
              className="transition-all duration-300 border-b-2 border-transparent"
            >
              Eventos
            </a>
            <div className="absolute left-0 hidden group-hover:block bg-eryndra-forest/90 border border-eryndra-gold rounded-md shadow-lg z-50">
              <ul className="py-2 px-2 text-eryndra-cream whitespace-nowrap">
                <li>
                  <a
                    href="/eventos/noche-country"
                    className="block px-4 py-2 hover:text-eryndra-gold transition-colors"
                  >
                    Noche Country
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <a href="/nosotras" className="hover:border-eryndra-gold transition-all duration-300 border-b-2 border-transparent">
          Sobre Nosotras
        </a>
        <a href="/contactanos" className="hover:border-eryndra-gold transition-all duration-300 border-b-2 border-transparent">
          Contacto
        </a>
      </nav>

      {/* Menú móvil (pendiente de desarrollo si quieres un desplegable) */}
    </header>
    {isMenuOpen && (
      <nav className="md:hidden fixed top-10 left-0 w-full bg-eryndra-forest/95 z-20 text-eryndra-cream text-center text-lg font-medium space-y-4 py-6 transition-all duration-300">
        <a
          href="/celebraciones"
          className="block hover:text-eryndra-gold transition-colors"
          onClick={() => setIsMenuOpen(false)}
        >
          Celebraciones a medida
        </a>
        <a
          href="/bailes"
          className="block hover:text-eryndra-gold transition-colors"
          onClick={() => setIsMenuOpen(false)}
        >
          Bailes de fantasía
        </a>
        <a
          href="/eventos"
          className="block hover:text-eryndra-gold transition-colors"
          onClick={() => setIsMenuOpen(false)}
        >
          Eventos literarios
        </a>
        <a
          href="/eventos/noche-country"
          className="block hover:text-eryndra-gold transition-colors"
          onClick={() => setIsMenuOpen(false)}
        >
          Noche Country
        </a>
        <hr className="mx-auto border-eryndra-gold w-2/3" />
        <a
          href="/nosotras"
          className="block hover:text-eryndra-gold transition-colors"
          onClick={() => setIsMenuOpen(false)}
        >
          Sobre Nosotras
        </a>
        <a
          href="/contactanos"
          className="block hover:text-eryndra-gold transition-colors"
          onClick={() => setIsMenuOpen(false)}
        >
          Contacto
        </a>
      </nav>
    )}
  </>
);
}